// extracted by mini-css-extract-plugin
module.exports = {"googlepay":"googlepay-1Jd1d","applepay":"applepay-37fC7"};